import { render, staticRenderFns } from "./SupportRequestForm.vue?vue&type=template&id=0132e95c"
import script from "./SupportRequestForm.vue?vue&type=script&lang=ts"
export * from "./SupportRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports